import { useAllTrafficUsed } from './queries/useAllTrafficUsed';
import { useSubscriptions } from './queries/useSubscriptions';

export default function useTrafficAvailable() {
  const subscriptions = useSubscriptions();
  const traffic = useAllTrafficUsed();
  if (!traffic) return undefined;
  return subscriptions.reduce(
    (acc, s) => acc + traffic[s.id].bytes_allowed - traffic[s.id].bytes_used,
    0
  );
}
